import { useEffect } from 'react';
import { useContextMenu } from '../hooks/useContextMenu';
import { ContextMenuPortal } from './common/ContextMenuPortal';

interface ResponseMenuProps {
	isVisible: boolean;
	onRegenerate: () => void;
	onPlay: () => void;
	onCopy: () => void;
	onCopyAsMarkdown: () => void;
	onBadResponse: () => void;
	onGoodResponse: () => void;
	feedback?: -1 | 0 | 1;
}

export function ResponseMenu({
	isVisible,
	onPlay,
	onCopy,
	onCopyAsMarkdown,
	onBadResponse,
	onGoodResponse,
	feedback = 0,
}: ResponseMenuProps) {
	const {
		contextMenuOpen,
		toggleContextMenu,
		closeContextMenu,
		menuPosition,
		menuRef,
		handleMenuAction,
	} = useContextMenu();

	useEffect(() => {
		if (!isVisible) {
			closeContextMenu();
		}
	}, [isVisible, closeContextMenu]);

	if (!isVisible) return null;
	return (
		<div className="flex items-center gap-2">
			{/* <button onClick={onRegenerate}>Regenerate</button> */}

			<button
				className="icon-btn"
				onClick={onPlay}
				title="Read aloud"
				type="button"
				aria-label="Read aloud"
			>
				<i className="fas fa-volume-up" />
			</button>

			<button
				className="icon-btn"
				onClick={onCopy}
				title="Copy to clipboard"
				type="button"
				aria-label="Copy to clipboard"
			>
				<i className="fas fa-copy" />
			</button>
			<button
				className="icon-btn"
				onClick={onGoodResponse}
				title="Good response"
				type="button"
				aria-label="Good response"
			>
				<i
					className={`fas fa-thumbs-up${feedback === 1 ? ' feedback-good' : ''}`}
				/>
			</button>
			<button
				className="icon-btn"
				onClick={onBadResponse}
				title="Bad response"
				type="button"
				aria-label="Bad response"
			>
				<i
					className={`fas fa-thumbs-down${feedback === -1 ? ' feedback-bad' : ''}`}
				/>
			</button>
			<div>
				<button
					className="icon-btn"
					onClick={(e) => toggleContextMenu('response-more', e, {offsetX: -150, offsetY: 5,})}
					title="More options"
					type="button"
					aria-label="More options"
					aria-expanded={contextMenuOpen === 'response-more'}
				>
					<i className="fas fa-ellipsis-h" />
				</button>
				{contextMenuOpen === 'response-more' && menuPosition && (
					<ContextMenuPortal x={menuPosition.x} y={menuPosition.y}>
						<div
							ref={menuRef}
							className="bg-neutral-600 border border-neutral-400 shadow-medium min-w-[170px] text-left rounded-large overflow-hidden"
						>
							<button
								type="button"
								className="flex p-2 px-3 w-full border-0 bg-transparent cursor-pointer text-left text-neutral-white hover:bg-red-600 hover:text-neutral-white"
								onClick={handleMenuAction(onCopyAsMarkdown)}
							>
								Copy as Markdown
							</button>
						</div>
					</ContextMenuPortal>
				)}
			</div>
		</div>
	);
}
